// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__1EgYZ","label":"Category_label__2fczq","content":"Category_content__1g8z6","header":"Category_header__1H42r","location":"Category_location__2DqqH"};